var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 53,
    rx: 10,
    fill: "#EFA922"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_40)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.4 34.8286V39.3714H12.1143V34.8286C12.1143 34.4269 12.2738 34.0418 12.5578 33.7578C12.8418 33.4738 13.2269 33.3143 13.6286 33.3143H40.8857C41.2873 33.3143 41.6725 33.4738 41.9565 33.7578C42.2404 34.0418 42.4 34.4269 42.4 34.8286Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6571 22.7143H19.6857V33.3143H16.6571V22.7143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7143 22.7143H25.7429V33.3143H22.7143V22.7143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7714 22.7143H31.8V33.3143H28.7714V22.7143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8286 22.7143H37.8571V33.3143H34.8286V22.7143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9143 40.5071H10.6C10.2994 40.5051 10.0117 40.3848 9.79911 40.1723C9.58656 39.9597 9.46626 39.672 9.46428 39.3714C9.46626 39.0708 9.58656 38.7831 9.79911 38.5705C10.0117 38.358 10.2994 38.2377 10.6 38.2357H43.9143C44.2149 38.2377 44.5026 38.358 44.7152 38.5705C44.9277 38.7831 45.048 39.0708 45.05 39.3714C45.048 39.672 44.9277 39.9597 44.7152 40.1723C44.5026 40.3848 44.2149 40.5051 43.9143 40.5071V40.5071Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.446 14.7643L27.8174 9.31283C27.4537 9.1917 27.0605 9.1917 26.6968 9.31283L13.0683 14.7643C12.7945 14.8876 12.5603 15.0846 12.3918 15.3333C12.2234 15.5819 12.1273 15.8725 12.1143 16.1725V21.2C12.1143 21.6016 12.2738 21.9867 12.5578 22.2707C12.8418 22.5547 13.2269 22.7143 13.6286 22.7143H40.8857C41.2873 22.7143 41.6725 22.5547 41.9565 22.2707C42.2404 21.9867 42.4 21.6016 42.4 21.2V16.1725C42.387 15.8725 42.2909 15.5819 42.1224 15.3333C41.954 15.0846 41.7198 14.8876 41.446 14.7643V14.7643ZM27.2571 18.9285C26.8079 18.9285 26.3687 18.7953 25.9952 18.5457C25.6217 18.2962 25.3305 17.9414 25.1586 17.5264C24.9867 17.1113 24.9417 16.6546 25.0293 16.214C25.117 15.7734 25.3333 15.3686 25.651 15.051C25.9687 14.7333 26.3734 14.517 26.814 14.4293C27.2546 14.3417 27.7113 14.3867 28.1264 14.5586C28.5414 14.7305 28.8962 15.0216 29.1458 15.3952C29.3953 15.7687 29.5286 16.2079 29.5286 16.6571C29.5286 17.2595 29.2892 17.8373 28.8633 18.2633C28.4373 18.6892 27.8596 18.9285 27.2571 18.9285Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_40"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.3429,
    height: 36.3429,
    fill: "white",
    transform: "translate(9.08571 6.05713)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/Bank.83b6fa4b2e7fcd4adae3c57af4199d9d.svg";
export { ForwardRef as ReactComponent };